import { render, staticRenderFns } from "./IconUitroepteken.vue?vue&type=template&id=ed25be46"
import script from "./IconUitroepteken.vue?vue&type=script&lang=ts"
export * from "./IconUitroepteken.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports